/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Styles = (theme) => {
    const { palette } = theme;
    return {
        slider_container: {
            '&.slider-container': {
                fontFamily: "'Hind', sans-serif",
                [theme.breakpoints.down('576')]: {
                    marginLeft: '0px',
                    marginRight: '0px',
                    '& .col': {
                        padding: '0',
                        lineHeight: '0',
                        '& .pricelist': {
                            lineHeight: 'normal',
                        },
                    },
                },
                '& .slick-arrow': {
                    cursor: 'pointer',
                },
                '& .slick-prev, & .slick-next': {
                    top: '33%',
                    '&:before': {
                        content: '""',
                        fontSize: '0',
                    },
                },
                '& .slick-slide': {
                    paddingRight: '10px',
                    paddingLeft: '10px',
                    height: '100%',
                    [theme.breakpoints.down('576')]: {
                        paddingLeft: '0',
                    },
                    '& img, & source': {
                        width: '100% !important',
                        margin: 'auto',
                        height: 'auto !important',
                    },
                    '& .slide-text': {
                        color: '#212324',
                        marginTop: '8px',
                        marginBottom: '8px',
                        fontSize: '1rem',
                        lineHeight: 1.25,
                        fontWeight: '700',
                        wordBreak: 'break-word',
                        [theme.breakpoints.down('sm')]: {
                            fontWeight: '400',
                        },
                    },
                    '&.slick-active': {
                        [theme.breakpoints.down('576')]: {
                            paddingLeft: '0',
                        },
                    },
                },
                '& .text-icon': {
                    color: palette.common?.gray_900,
                },
                '& .wrapUpPrice': {
                    fontWeight: '700',
                    width: '100%',
                    textDecoration: 'none',
                    [theme.breakpoints.between('768', '1025')]: {
                        fontSize: '0.875rem',
                        letterSpacing: '-0.6px',
                    },
                    float: 'left',
                    '& .line': {
                        textDecoration: 'line-through',
                    },
                },
                '& .slick-dots': {
                    bottom: '-40px',
                    '& li': {
                        height: '12px',
                        width: '12px',
                        '& button': {
                            height: '12px',
                            width: '12px',
                            '&:before': {
                                fontSize: '1.25rem',
                                content: '""',
                                border: `1px solid ${palette.common?.black}`,
                                borderRadius: '50%',
                                width: '12px',
                                height: '12px',
                            },
                        },
                    },
                    '& li.slick-active': {
                        '& button:before': {
                            background: palette.common?.black,
                        },
                    },
                },
                '& .slick-disabled': {
                    opacity: '0.4',
                    display: 'none !important',
                    '&:hover': {
                        cursor: 'default',
                    },
                },
                '&.slick-vertical': {
                    minWidth: '124px !important',
                    [theme.breakpoints.down('1264')]: {
                        top: '4%',
                    },
                    [theme.breakpoints.up('1264')]: {
                        top: '3%',
                    },
                    '& .slick-prev': {
                        top: '-27px',
                        left: '33%',
                        opactiy: 0.9,
                        zIndex: 1,
                    },
                    '& .slick-next': {
                        right: '43%',
                        opacity: 0.9,
                        bottom: '-2%',
                    },
                    '& .slick-prev, .slick-next': {
                        width: '30px',
                        border: '1px solid black',
                        cursor: 'pointer',
                        height: '25px',
                        outline: 0,
                        position: 'absolute',
                        fontSize: 0,
                        transform: 'rotate(90deg)',
                        lineHeight: 0,
                        fill: 'black',
                    },
                    '& .slick-list': {
                        overflow: 'hidden',
                        padding: 'unset !important',
                    },
                    '& .slick-track': {
                        opacity: 1,
                        height: '419px',
                        width: 'unset !important',
                        minWidth: '110px !important',
                        transform: 'translate3d(-600px, 0px, 0px) !important',
                    },
                    '& .slick-slide': {
                        cursor: 'pointer',
                        paddingLeft: 'unset !important',
                        paddingRight: '14px !important',
                        border: 'unset !important',
                        '& img': {
                            height: '110px !important',
                            minWidth: '110px !important',
                            marginBottom: '14px !important',
                        },
                    },
                    '& .unset-top': {
                        top: 'unset !important',
                    },
                },
                '& .sharePlantsImg': {
                    height: '100%',
                    maxHeight: '210px',
                    maxWidth: '242px',
                    '& img': {
                        [theme.breakpoints.up('993')]: {
                            width: '272px !important',
                        },
                    },
                },
                '& .title': {
                    // wordBreak: 'inherit',
                    width: '60%',
                    [theme.breakpoints.down('994')]: {
                        fontSize: '0.875rem',
                        lineHeight: '0.875rem',
                    },
                    float: 'left',
                    paddingRight: '5px',
                    color: '#212121',
                    fontWeight: '400',
                    letterSpacing: '0',
                    '&.plant-occasion-title': {
                        color: 'black',
                        fontSize: '16px !important',
                        lineHeight: '1.50rem !important',
                        letterSpacing: '0.8px',
                        opacity: '1',
                        width: 'unset !important',
                    },
                },
            },
        },
        dots_true_arrows_false: {
            '& .slider-container': {
                marginLeft: '-25px',
                marginRight: '-25px',
            },
        },
    };
};

export default Styles;
